/**
 * PAPPO — useNotification hook
 * Gere o estado e subscrição de notificações push.
 */

import { useState, useCallback } from 'react';
import { isPushSupported, subscribeToPush, unsubscribeFromPush } from '../services/push';

export function useNotification() {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const supported = isPushSupported();

  const subscribe = useCallback(async () => {
    setIsLoading(true);
    const ok = await subscribeToPush();
    setIsSubscribed(ok);
    setIsLoading(false);
    return ok;
  }, []);

  const unsubscribe = useCallback(async () => {
    setIsLoading(true);
    const ok = await unsubscribeFromPush();
    if (ok) setIsSubscribed(false);
    setIsLoading(false);
    return ok;
  }, []);

  return { supported, isSubscribed, isLoading, subscribe, unsubscribe };
}
